/*
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-08-22 23:35:47
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-10-11 21:44:11
 */

import {commonConfig} from "@/api/api";

const appInfo = {
  // appid: 'wxe1acd2a4170297cd',
  // appid: 'wxf51de93710e8c664',
  appid: 'wx27ed22776e82c8cd',
  scope: 'snsapi_base',
  state: 'spdr1234',
  responseType: 'code'
}

export const map_key = '0c6ea0e2c174d400746b41aee1db0db4' // 高德AK
export const cryptoKey = 'o58.topAAABBBZZZ' // 16位密钥
export const ivSet = 'qcwp'
export const loginUrl = (redirectUri) => {
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appInfo.appid}&redirect_uri=${redirectUri}&response_type=${appInfo.responseType}&scope=${appInfo.scope}&state=${appInfo.state}#wechat_redirect`
}

